import React, {useContext } from "react";
import { PJContext } from "./pj-context"
import {supFractions} from "../helpers";
import CONSTS from "./pj-constants";



function PJBreadCrumbs(props) {
    const { state, dispatch, data } = useContext(PJContext);

    return  (
        <div className={"journey-breadcrumbs "}>
            <button className="crumb active reset-journey" onClick={e => dispatch({ type: CONSTS.CLOSE_JOURNEY, data:data}) } type="button">Choose plan ></button>
            <button className={"crumb " + ((state.currentStep >= CONSTS.STEP_1_START) ? 'active' : '')} type="button">order summary ></button>
            <button className={"crumb "  + ((state.currentStep > CONSTS.STEP_1_START)? 'active' : '')} type="button">checkout ></button>
            <button className={"crumb "  + ((state.currentStep >= CONSTS.STEP_9_ORDER_COMPLETE)? 'active' : '')} type="button">complete</button>
        </div>
    );
}

export { PJBreadCrumbs };